// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {


    var productGalleryThumbsSwiper = new Swiper(".product-gallery-thumbnails", {
        modules: [Navigation, Thumbs],
        slidesPerView: 7.5,
        spaceBetween: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });

    var productGallerySwiper = new Swiper(".product-gallery", {
        modules: [Navigation, Thumbs],
        spaceBetween: 10,
        navigation: {
            nextEl: document.querySelector('.product-gallery .swiper-button-next'),
            prevEl: document.querySelector('.product-gallery .swiper-button-prev'),
        },
        thumbs: {
            swiper: productGalleryThumbsSwiper
        }
    });

});